import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs/operators';

@Injectable()
export class TranslocoTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly transloco = inject(TranslocoService);
  private lastTitleKey: string | null = null;

  constructor() {
    super();
    this.transloco.langChanges$.subscribe(() => this.applyTitle());
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.lastTitleKey = this.buildTitle(snapshot) ?? null;
    this.applyTitle();
  }

  private applyTitle(): void {
    if (!this.lastTitleKey) {
      return;
    }

    this.transloco
      .selectTranslate(this.lastTitleKey)
      .pipe(take(1))
      .subscribe((title) => {
        this.title.setTitle(title);
      });
  }
}
